import { Button } from "@albelli/arc-3-react/lib/Button/Button";
import React from "react";
import { useHistory } from "react-router-dom";

export const NavButton = props => {
  const history = useHistory();

  if (!props.href) throw new Error("href is required for NavButton");

  const navigateTo = (e, href) => {
    e.preventDefault();
    history.push(href);
  };

  return <Button onClick={e => navigateTo(e, props.href)} {...props} />;
};
